// Singleton background-music manager. Plays a looping track per room at a
// low volume, remembers the mute choice, and can "duck" (pause) e.g. while a
// TV title song plays. Survives route changes so music is continuous.
const VOLUME = 0.18; // keep it soft — never too loud

const manager = {
  audio: null,
  src: null,
  ducked: false,
  muted: (() => { try { return localStorage.getItem("ambient_muted") === "1"; } catch { return false; } })(),
  listeners: new Set(),

  _ensure() {
    if (!this.audio) {
      this.audio = new Audio();
      this.audio.loop = true;
      this.audio.preload = "auto";
      this.audio.volume = VOLUME;
    }
    return this.audio;
  },
  _apply() {
    if (!this.audio) return;
    if (this.muted || this.ducked) {
      this.audio.pause();
    } else if (this.src) {
      this.audio.volume = VOLUME;
      this.audio.play().catch(() => {});
    }
  },
  notify() { this.listeners.forEach((fn) => fn()); },
  subscribe(fn) { this.listeners.add(fn); return () => this.listeners.delete(fn); },

  setTrack(src) {
    this._ensure();
    if (this.src !== src) {
      this.src = src;
      this.audio.src = src;
    }
    this._apply();
  },
  setMuted(m) {
    this.muted = m;
    try { localStorage.setItem("ambient_muted", m ? "1" : "0"); } catch (err) { console.warn("Could not persist mute preference:", err); }
    this._apply();
    this.notify();
  },
  toggle() { this.setMuted(!this.muted); },
  duck(on) { this.ducked = on; this._apply(); },
};

export default manager;
